import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
import Confetti from '../../../../assets/background/objectifClasse/confetti.webp';
import LinePattern from 'assets/background/workInProgressBlock/line.webp';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '1rem',
      '@media (max-width:560px)': {
        flexDirection: 'column'
      }
    },
    objectif: {
      width: '100%'
    },
    progressContent: {
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: palette.background.dark,
      color: palette.common.white,
      padding: '10px',
      borderRadius: '10px',
      marginBottom: '10px',
      position: 'relative',
      overflow: 'hidden'
    },
    ca: {
      zIndex: 1
    },
    progress: {
      fontWeight: 800,
      zIndex: 1
    },
    progressBar: {
      width: (props: { objective: number; color: string }) =>
        `${props.objective}%`,
      backgroundColor: (props: { color: string; objective: number }) =>
        props.color,
      backgroundImage: (props: { color: string; objective: number }) =>
        `${props.objective !== 100 ? `url(${LinePattern})` : 'none'}`,
      height: '100%',
      top: 0,
      left: 0,
      position: 'absolute',
      animation: '$progressAnimation linear infinite',
      animationDuration: (props: { objective: number; color: string }) =>
        `${Math.round((50 * props.objective) / 100)}s`,
      backgroundPosition: '0% 0',
      borderRadius: (props: { objective: number; color: string }) =>
        `10px ${props.objective === 100 ? '10px 10px' : '20px 20px'} 10px`
    },
    '@keyframes progressAnimation': {
      '0%': {
        backgroundPosition: '0% 0'
      },
      '100%': {
        backgroundPosition: '100% 0'
      }
    },
    title: {
      backgroundImage: (props: { objective: number; color: string }) =>
        `${props.objective === 100 ? `url(${Confetti})` : ''}`,
      backgroundColor: (props: { objective: number; color: string }) =>
        `${
          props.objective === 100 ? props.color : palette.background.underBox
        }`,
      textAlign: 'center',
      color: (props: { objective: number; color: string }) =>
        `${props.objective === 100 ? 'white' : palette.text.primary}`,
      padding: '10px',
      borderRadius: '10px'
    },
    actions: {
      display: 'flex',
      gap: '10px',
      justifyContent: 'space-between',
      backgroundColor: palette.common.primaryBlue,
      borderRadius: palette.borderRadius.default,
      alignItems: 'center',
      '& > *': {
        flex: 1
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
